import { LanguageName, Theme } from '@components/AppBar/app-bar-state';
import { Nullable, Option } from '@customTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UserState {
  isParticipantWizardOpen: boolean;
  theme: Theme;
  isParticipantMode: boolean;
  participantToken: Nullable<string>;
  userToken: Nullable<string>;
  languageOptions: Option[];
  language: LanguageName;
}

const initialState: UserState = {
  isParticipantWizardOpen: true,
  theme: Theme.Light,
  isParticipantMode: false,
  participantToken: null,
  userToken: null,
  languageOptions: [],
  language: LanguageName.English,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setParticipantWizardOpen: (state, action: PayloadAction<boolean>) => {
      state.isParticipantWizardOpen = action.payload;
    },
    setTheme: (state, action: PayloadAction<Theme>) => {
      state.theme = action.payload;
    },
    setParticipantMode: (state, action: PayloadAction<boolean>) => {
      state.isParticipantMode = action.payload;
    },
    setParticipantToken: (state, action: PayloadAction<Nullable<string>>) => {
      state.participantToken = action.payload;
    },
    setUserToken: (state, action: PayloadAction<Nullable<string>>) => {
      state.userToken = action.payload;
    },
    setLanguageOptions: (state, action: PayloadAction<Option[]>) => {
      state.languageOptions = action.payload;
    },
    setLanguage: (state, action: PayloadAction<LanguageName>) => {
      state.language = action.payload;
    },
  },
});

export const {
  setParticipantWizardOpen,
  setTheme,
  setParticipantMode,
  setParticipantToken,
  setUserToken,
  setLanguageOptions,
  setLanguage,
} = userSlice.actions;
export default userSlice.reducer;
